import { catchError, delay, map, of, take, tap } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export interface GeoLocationResponse {
    country_code2: string;
}

@Injectable({
    providedIn: 'root',
})
export class UserCountryDetectorService {
    URL = `//${environment.domain}/${environment.apiPrefix}/geolocation`;

    private userCountry: string;

    constructor(private httpClient: HttpClient) {
        this.getUserGeolocationInfo()
            .pipe(
                take(1),
                tap((res) => (this.userCountry = (res as any).country_code2)),
            )
            .subscribe();
    }

    getUserGeolocationInfo() {
        if (this.userCountry) {
            return of({ country_code2: this.userCountry });
        }

        return this.httpClient.get<any>(this.URL).pipe(
            map((res) => ({ country_code2: res.country_code2 })),
            catchError(() => of(null)),
        );
    }

    getUserCountry = () => this.userCountry;
}
